module.exports = __webpack_public_path__ + "static/media/mentor.8d1e0b66.svg";